import {
  Report5SAuditsActionTypes,
  Report5SChartData,
  Report5SChartFilters,
  LoadChartRequestAction,
  LoadChartSuccessAction,
  LoadChartFailureAction,
  ClearChartAction,
} from '../../types/report5SAudits';

export const loadReport5SChart = (filters: Report5SChartFilters): LoadChartRequestAction => ({
  type: Report5SAuditsActionTypes.LOAD_CHART_REQUEST,
  payload: { filters },
});

export const loadReport5SChartSuccess = (data: Report5SChartData): LoadChartSuccessAction => ({
  type: Report5SAuditsActionTypes.LOAD_CHART_SUCCESS,
  payload: { data },
});

export const loadReport5SChartFailure = (error: string): LoadChartFailureAction => ({
  type: Report5SAuditsActionTypes.LOAD_CHART_FAILURE,
  payload: { error },
});

export const clearReport5SChart = (): ClearChartAction => ({
  type: Report5SAuditsActionTypes.CLEAR_CHART,
});
